<!-- @format -->
<template>
	<!-- v-click-outside:[popperRef]="onClickOutside" -->
	<div class="comment-box">
		<el-input
			ref="textareaRef"
			v-model="content"
			:rows="3"
			type="textarea"
			:placeholder="props.placeholder"
			resize="none"
			:disabled="disabledInput"
			@input="input"
		/>
		<div class="action-box">
			<el-button type="primary" :disabled="disabled" @click="onSubmit">{{ props.contentBtn }}</el-button>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { isNull, isEmpty } from '../utils';

	interface Props {
		placeholder: string;
		contentBtn: string;
		parentId?: string;
		reply?: any;
		disabledInput?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {});
	//const popperRef = ref();
	const textareaRef = ref();
	const content = ref('');
	const disabled = ref(true);
	const emit = defineEmits<{
		(e: 'hide', event: Event): void;
		(e: 'close'): void;
	}>();

	const input = () => {
		isEmpty(content.value.replace(/&nbsp;|<br>| /g, '')) ? (disabled.value = true) : (disabled.value = false);
	};

	const submit: any = inject('submit');

	const onSubmit = () => {
		submit({
			content: props.reply
				? `回复 <span style="color: var(--u-color-success-dark-2);">@${props.reply.user.username}:</span> ${content.value}`
				: content.value,
			parentId: isNull(props.parentId, null),
			reply: props.reply,
			clear: () => {
				//清理输入框提交的数据
				clearData();
				// 关闭评论框事件
				emit('close');
			},
		});
	};

	//清理提交后输入框和图片列表数据
	const clearData = () => {
		// 清空评论框内容
		content.value = '';
		//提交按钮禁用
		disabled.value = true;
	};

	// function onClickOutside(event: Event) {
	// 	// 评论框有内容情况下不执行操作
	// 	if (isEmpty(content.value)) {
	// 		emit('hide', event);
	// 	}
	// }

	defineExpose({
		focus: () => (textareaRef as any).value?.focus(),
	});
</script>

<style lang="scss" scoped>
	.comment-box {
		width: 100%;
		position: relative;
		overflow: hidden;

		.action-box {
			display: flex;
			align-items: center;
			margin-top: 5px;

			.el-button {
				margin-left: auto;
			}
		}
	}
</style>
